import * as React from 'react';
import styled from 'styled-components';
// import Header from './Header';

interface IProps {
  children: React.ReactNode;
}

const Layout = styled.div`
  padding: 0;
`;

// const Wrap = styled.div`
//     position: relative;
//     margin: 0 auto;
//     width: 100%;
// `;

const LayoutStyle: React.SFC<IProps> = ({ children }) => (
  <Layout>
    {/* <Header /> */}
    {children}
    {/* <Footer /> */}
  </Layout>
);

// const WrapStyle = (props: Props) => {
//     const { children } = props;
//     return (
//       <Wrap>{children}</Wrap>);
// };


// LayoutStyle.Wrap = WrapStyle;

export default LayoutStyle;


// WEBPACK FOOTER //
// ./src/styles/layout/default.tsx